import propTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { CONSENT_STATUS } from '../../constants';
import * as S from './styles';

const inlineErrorKeyByStatus = {
  [CONSENT_STATUS.noSelection]: 'select-context.no-selection',
  [CONSENT_STATUS.failed]: 'select-context.failed',
};

const ConsentContextForm = ({
  email,
  contexts,
  selectedOptionId,
  status,
  onSelect,
  onSubmit,
}) => {
  const [t] = useTranslation('calendar');

  const isSending = status === CONSENT_STATUS.sending;
  const inlineErrorKey = inlineErrorKeyByStatus[status];

  const handleSubmit = event => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <>
      <S.Title $align="center">{t('select-context.title')}</S.Title>
      <S.Paragraph $align="center">
        <Trans
          i18nKey="select-context.description"
          ns="calendar"
          values={{ email }}
          components={{ strong: <strong /> }}
        />
      </S.Paragraph>

      <S.Form onSubmit={handleSubmit}>
        {contexts.map(option => (
          <S.OptionItem
            key={option.optionId}
            htmlFor={`consent-context-${option.optionId}`}
            $selected={selectedOptionId === option.optionId}
          >
            <input
              id={`consent-context-${option.optionId}`}
              type="radio"
              name="consent-context"
              value={option.optionId}
              checked={selectedOptionId === option.optionId}
              onChange={() => onSelect(option.optionId)}
            />
            <span>
              <strong>{option.condominium}</strong>
              <small>
                {option.isCurrent
                  ? `${option.unity} · ${t('select-context.current-badge')}`
                  : option.unity}
              </small>
            </span>
          </S.OptionItem>
        ))}

        <S.SubmitButton
          type="submit"
          variant="contained"
          color="porterBlue"
          centered
          loading={isSending}
          disabled={isSending}
        >
          {t('select-context.submit')}
        </S.SubmitButton>

        {inlineErrorKey && (
          <S.StatusMessage role="status" $variant="danger">
            {t(inlineErrorKey)}
          </S.StatusMessage>
        )}
      </S.Form>
    </>
  );
};

ConsentContextForm.propTypes = {
  email: propTypes.string.isRequired,
  contexts: propTypes.arrayOf(
    propTypes.shape({
      optionId: propTypes.string.isRequired,
      condominium: propTypes.string,
      unity: propTypes.string,
      isCurrent: propTypes.bool,
    }),
  ).isRequired,
  selectedOptionId: propTypes.string,
  status: propTypes.string.isRequired,
  onSelect: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
};

ConsentContextForm.defaultProps = {
  selectedOptionId: '',
};

export default ConsentContextForm;
